var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavedSearchableRecords(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0671 66.7081C50.0671 59.4134 55.9806 53.5 63.2752 53.5H279.717C287.012 53.5 292.925 59.4135 292.925 66.7081V109.11C292.925 116.405 287.012 122.318 279.717 122.318H63.2752C55.9806 122.318 50.0671 116.405 50.0671 109.11V66.7081ZM65.9168 69.3497V106.469H277.075V69.3497H65.9168Z",
    fill: "#102F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.292 81.501L88.2275 95.2629",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1238,
    y: 130.865,
    width: 304.306,
    height: 77.7886,
    rx: 9.5,
    fill: "#102F5D",
    stroke: "#102F5D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.0537,
    y: 144.69,
    width: 49.2429,
    height: 51.0335,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0403,
    y: 144.69,
    width: 151.31,
    height: 27.7551,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0403,
    y: 182.293,
    width: 68.0447,
    height: 13.4299,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 278.268,
    y: 172.445,
    width: 33.127,
    height: 21.4878,
    rx: 10.7439,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1238,
    y: 217.711,
    width: 304.306,
    height: 77.7886,
    rx: 9.5,
    fill: "#102F5D",
    stroke: "#102F5D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.0537,
    y: 231.536,
    width: 49.2429,
    height: 51.0335,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0403,
    y: 231.536,
    width: 151.31,
    height: 27.7551,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0403,
    y: 269.14,
    width: 68.0447,
    height: 13.4299,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 278.268,
    y: 259.291,
    width: 33.127,
    height: 21.4878,
    rx: 10.7439,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.422 115.823C303.996 132.405 298.314 153.61 281.732 163.184C265.149 172.758 243.945 167.076 234.37 150.493C224.796 133.911 230.478 112.706 247.061 103.132C263.644 93.5581 284.848 99.2398 294.422 115.823Z",
    fill: "#102F5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.718 99.0745C225.895 109.942 219.445 134.012 230.313 152.836C240.172 169.913 260.897 176.805 278.713 169.824L283.95 178.894C285.585 181.728 286.604 184.875 286.937 188.13C287.271 191.385 288.289 194.532 289.925 197.366L306.375 225.858C309.647 231.525 314.08 236.436 319.384 240.269L320.634 242.433C322.186 245.122 325.625 246.043 328.314 244.491C331.003 242.938 331.924 239.5 330.372 236.81L329.122 234.646C328.932 230.534 328.137 226.487 326.776 222.631C325.347 218.582 319.899 216.797 317.752 213.079C317.327 212.342 317.063 211.561 316.951 210.784C316.732 209.275 314.914 206.125 313.716 205.182C313.099 204.696 312.555 204.077 312.13 203.341C311.705 202.604 311.441 201.823 311.328 201.046C311.11 199.537 309.291 196.387 308.094 195.444C307.477 194.958 306.933 194.339 306.507 193.602C304.373 189.905 305.508 184.181 302.159 181.531C301.615 181.101 301.049 180.697 300.463 180.321C297.642 178.514 295.295 176.056 293.62 173.154L288.495 164.279C303.848 152.421 308.447 130.744 298.48 113.48C287.612 94.6561 263.542 88.2066 244.718 99.0745ZM238.428 148.151C230.148 133.809 235.062 115.47 249.404 107.19C263.745 98.9093 282.084 103.823 290.365 118.165C298.645 132.507 293.731 150.846 279.389 159.126C265.047 167.406 246.708 162.492 238.428 148.151Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.88 229.608C303.403 235.711 308.086 241.059 313.66 245.354L314.138 246.183C317.762 252.459 325.787 254.609 332.064 250.986C338.34 247.362 340.49 239.337 336.867 233.06L336.49 232.408C336.134 228.211 335.244 224.087 333.848 220.134C332.349 215.886 328.966 213.24 327.288 211.928C327.244 211.894 327.2 211.86 327.158 211.827C326.942 211.658 326.745 211.504 326.562 211.362C325.843 210.801 325.356 210.422 324.891 210.003C324.587 209.728 324.418 209.543 324.33 209.437C323.958 207.292 322.888 205.22 322.196 204.021C321.519 202.848 320.299 200.945 318.682 199.558C318.289 197.463 317.251 195.456 316.574 194.283C315.881 193.084 314.622 191.122 312.95 189.727C312.9 189.591 312.816 189.332 312.717 188.888C312.592 188.332 312.517 187.879 312.415 187.268C312.35 186.879 312.275 186.426 312.169 185.841L312.167 185.83C311.779 183.683 310.915 178.895 306.813 175.65C306.074 175.065 305.305 174.517 304.509 174.006C302.697 172.846 301.191 171.268 300.115 169.404L298.031 165.795C312.263 151.14 315.695 128.297 304.975 109.73C292.036 87.3189 263.379 79.6403 240.968 92.5793C218.557 105.518 210.879 134.175 223.818 156.586C234.424 174.956 255.581 183.422 275.211 178.759L277.454 182.644C278.562 184.562 279.251 186.692 279.477 188.895C279.918 193.202 281.266 197.367 283.43 201.116L299.88 229.608Z",
    stroke: "#102F5D",
    strokeWidth: 15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedSearchableRecords);
export default __webpack_public_path__ + "static/media/saved-searchable-records.1084415d890d27c19e43a2ba51510d4b.svg";
export { ForwardRef as ReactComponent };